import type { RecursivePartial } from '#types/utils'
import type { CheckoutConfig } from '#types/config/pages/checkout'

export default {
  legalCheckboxStep: 'shipping',
  contactFieldsOrder: (() => ['phone', 'email']) as unknown as CheckoutConfig['contactFieldsOrder'],
} satisfies RecursivePartial<CheckoutConfig>
